import { LocalizationProvider, DesktopDatePicker } from '@mui/lab';
import { useMediaQuery } from '@mui/material';
import { FC, useState } from 'react';
import DateAdapter from '@mui/lab/AdapterDateFns';
import { theme } from '../../../../styles/theme';
import { WhiteBorderTextField } from '../../../../helpers/styles';
import { isEqual } from 'date-fns';

interface IClosingCalendarDatePicker {
  date: Date;
  handleNavigate: (newDate: Date) => void;
}

export const ClosingCalendarDatePicker: FC<IClosingCalendarDatePicker> = ({
  date,
  handleNavigate
}) => {
  const [newDate, setNewDate] = useState(date);
  const isExtraLargeScreen = useMediaQuery('(min-width:2100px)');

  return (
    <LocalizationProvider dateAdapter={DateAdapter}>
      <DesktopDatePicker
        label="Date"
        inputFormat="MM/dd/yyyy"
        onChange={(date: any) => {
          setNewDate(date);
        }}
        onAccept={date => {
          handleNavigate(date);
        }}
        value={date}
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: isExtraLargeScreen ? [-58, 2] : [24, 2], // Apply offset only on smaller screens
              },
            },
            {
              name: 'preventOverflow',
              options: {
                mainAxis: false, // Disable shifting along the main axis
                altAxis: true, // Allow shifting along the secondary axis
                tether: false, // Disable tethering to prevent the popper from repositioning
              },
            },
            {
              name: 'setPopperWidth',
              enabled: true,
              phase: 'beforeWrite',
              requires: ['computeStyles'],
              fn: ({ state }) => {
                // Ensure the Popper width matches the input field width and is responsive
                if(!isExtraLargeScreen) {
                  const inputWidth = state.rects.reference.width;
                  const minWidth = 350; // You can set a minimum width to avoid it being too small
                  state.styles.popper.width = `${Math.max(inputWidth, minWidth)}px`;
                }
              },
            },
          ],
        }}
        renderInput={(params: any) => (
          <WhiteBorderTextField
            {...params}
            size="small"
            required={false}
            fullWidth
            error={false}
            value={date}
            sx={{
              svg: { color: theme.palette.common.white },
              input: { color: theme.palette.common.white },
              label: {
                color: theme.palette.common.white,
                fontWeight: 'bold',
                backgroundColor: `transparent!important`,
                borderColor: theme.palette.common.white
              }
            }}
            onBlur={() => {
              if (!isEqual(newDate, date)) {
                handleNavigate(newDate);
              }
            }}
            onKeyDown={e => {
              e.key === 'Enter' && handleNavigate(newDate);
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};
